import type {
  LegSolution,
  SearchPointToPointTicketData,
} from '~models/Transportation/PointToPointTicket';
import type { SearchIdMappedSearchPointToPointTicketData } from '~types/pointToPointTicket';

export const addSearchIdToLegSolution = (legSolution: LegSolution, searchId: string) => {
  return {
    ...legSolution,
    searchId,
  };
};

/**
 * @description 검색 결과 데이터에 searchId를 맵핑하여 반환
 * 페이징 해온 legSolutions 당 searchId가 상이하기 때문에 맵핑 필요
 */
export const mapDataWithSearchId = (
  data: SearchPointToPointTicketData,
): SearchIdMappedSearchPointToPointTicketData => {
  return {
    ...data,
    outboundLegSolutionSummary: data.outboundLegSolutionSummary
      ? {
          ...data.outboundLegSolutionSummary,
          legSolutions: data.outboundLegSolutionSummary.legSolutions.map((legSolution) =>
            addSearchIdToLegSolution(legSolution, data.id),
          ),
        }
      : null,
    inboundLegSolutionSummary: data.inboundLegSolutionSummary
      ? {
          ...data.inboundLegSolutionSummary,
          legSolutions: data.inboundLegSolutionSummary.legSolutions.map((legSolution) =>
            addSearchIdToLegSolution(legSolution, data.id),
          ),
        }
      : null,
    hasNext: !!data.outboundSearchOfferResult,
  };
};
